(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3226],{

/***/ 32700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ MediaQuery; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(42112);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/utils/get-size/get-size.js
var get_size = __webpack_require__(30324);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/utils/rem/rem.js
var rem = __webpack_require__(58349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/functions/fns/breakpoints/breakpoints.js
var breakpoints = __webpack_require__(68659);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/MediaQuery/MediaQuery.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme, { smallerThan, largerThan, query, styles }) => {
  const media = {};
  const minWidth = (0,get_size/* getSize */.a)({ size: largerThan, sizes: theme.breakpoints });
  const maxWidth = (0,get_size/* getSize */.a)({ size: smallerThan, sizes: theme.breakpoints });
  const _styles = typeof styles === "function" ? styles(theme) : styles;
  if (largerThan !== void 0 && smallerThan !== void 0) {
    media[`@media (min-width: ${(0,rem.em)(minWidth)}) and (max-width: ${(0,rem.em)((0,breakpoints/* getBreakpointValue */.oI)(maxWidth) - 1)})`] = _styles;
  } else {
    if (largerThan !== void 0) {
      media[`@media (min-width: ${(0,get_size/* getSize */.a)({ size: largerThan, sizes: theme.breakpoints })})`] = _styles;
    }
    if (smallerThan !== void 0) {
      media[`@media (max-width: ${(0,rem.em)((0,breakpoints/* getBreakpointValue */.oI)((0,get_size/* getSize */.a)({ size: smallerThan, sizes: theme.breakpoints })) - 1)})`] = _styles;
    }
  }
  if (query) {
    media[`@media ${query}`] = _styles;
  }
  return { media };
});

/* harmony default export */ var MediaQuery_styles = (useStyles);
//# sourceMappingURL=MediaQuery.styles.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/MediaQuery/MediaQuery.js




function MediaQuery(props) {
  var _a;
  const { children, smallerThan, largerThan, query, styles, className } = (0,MantineProvider/* useComponentDefaultProps */.N4)("MediaQuery", {}, props);
  const { classes, cx } = MediaQuery_styles({ smallerThan, largerThan, query, styles }, { name: "MediaQuery" });
  const child = react.Children.only(children);
  if (typeof child === "object" && child !== null && "props" in child) {
    return react.cloneElement(child, {
      className: cx(classes.media, (_a = child.props) == null ? void 0 : _a.className, className)
    });
  }
  return child;
}
MediaQuery.displayName = "@mantine/core/MediaQuery";


//# sourceMappingURL=MediaQuery.js.map


/***/ }),

/***/ 65180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useWindowScroll; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);
/* harmony import */ var _use_window_event_use_window_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12667);



function getScrollPosition() {
  return typeof window !== "undefined" ? { x: window.pageXOffset, y: window.pageYOffset } : { x: 0, y: 0 };
}
function scrollTo({ x, y }) {
  if (typeof window !== "undefined") {
    const scrollOptions = { behavior: "smooth" };
    if (typeof x === "number") {
      scrollOptions.left = x;
    }
    if (typeof y === "number") {
      scrollOptions.top = y;
    }
    window.scrollTo(scrollOptions);
  }
}
function useWindowScroll() {
  const [position, setPosition] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({ x: 0, y: 0 });
  (0,_use_window_event_use_window_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useWindowEvent */ .s)("scroll", () => setPosition(getScrollPosition()));
  (0,_use_window_event_use_window_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useWindowEvent */ .s)("resize", () => setPosition(getScrollPosition()));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setPosition(getScrollPosition());
  }, []);
  return [position, scrollTo];
}


//# sourceMappingURL=use-window-scroll.js.map


/***/ }),

/***/ 27665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconArrowRight; }
/* harmony export */ });
/* harmony import */ var _createReactComponent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61304);
/**
 * @tabler/icons-react v2.42.0 - MIT
 */



var IconArrowRight = (0,_createReactComponent_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("arrow-right", "IconArrowRight", [
  ["path", { d: "M5 12l14 0", key: "svg-0" }],
  ["path", { d: "M13 18l6 -6", key: "svg-1" }],
  ["path", { d: "M13 6l6 6", key: "svg-2" }]
]);


//# sourceMappingURL=IconArrowRight.js.map


/***/ }),

/***/ 35392:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"https://static-cny.howxm.com/_next/static/media/boy.87d722c1.png","height":200,"width":200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAz0lEQVR42mOAgFBGBjSQllXOzgACTnYWTCA6IdA9oizR73KRu8+hOL96GwY0IMSvYfDH0tn9f5y3138Xc9NnBYUcafu31rMwgEBvWZzmjNr8/9158T/zAh3+xNjp/HX1ZciDa7+095DZ5U0L/93Ztfz/iVWz/2+f1vEuy3+yZaL9cnmG9tYeJufo6+JBkk4qe+d1n949q///vLpZZyYnz8kucpitxwACtxk0JX+/YxBlyGHgiPOpdLIKmKfCgA6OHHDg+P//EhMDEpgV38MEAJJOS4F0QJ/WAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 23127:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"https://static-cny.howxm.com/_next/static/media/bg.6e69af8f.jpg","height":1671,"width":2417,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAYACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAAr4H/xAAaEAEAAgMBAAAAAAAAAAAAAAABAxEAAhIj/9oACAEBAAE/AOJSVdZfNbpz/8QAFREBAQAAAAAAAAAAAAAAAAAAAQD/2gAIAQIBAT8AAC//xAAWEQEBAQAAAAAAAAAAAAAAAAABABH/2gAIAQMBAT8AXb//2Q==","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 8733:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"https://static-cny.howxm.com/_next/static/media/footer-bg.be07e8fe.jpg","height":1748,"width":2604,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAAr4H/xAAYEAACAwAAAAAAAAAAAAAAAAABAwACM//aAAgBAQABPwArsHamf//EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQIBAT8Af//EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQMBAT8Af//Z","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 93726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90773);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14512);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var GridBackground = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().grid), className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GridBackground);


/***/ }),

/***/ 96895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ site_SiteLayout; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-disclosure/use-disclosure.js
var use_disclosure = __webpack_require__(36078);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/AppShell/Header/Header.js + 2 modules
var Header = __webpack_require__(34048);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(23723);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/MediaQuery/MediaQuery.js + 1 modules
var MediaQuery = __webpack_require__(32700);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/HoverCard/HoverCard.js + 4 modules
var HoverCard = __webpack_require__(75686);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Flex/Flex.js + 1 modules
var Flex = __webpack_require__(26385);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/utils/rem/rem.js
var rem = __webpack_require__(58349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(42112);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/utils/get-size/get-size.js
var get_size = __webpack_require__(30324);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Burger/Burger.styles.js


const sizes = {
  xs: (0,rem/* rem */.h)(12),
  sm: (0,rem/* rem */.h)(18),
  md: (0,rem/* rem */.h)(24),
  lg: (0,rem/* rem */.h)(34),
  xl: (0,rem/* rem */.h)(42)
};
var useStyles = (0,create_styles/* createStyles */.k)((theme, { color, transitionDuration }, { size }) => {
  const sizeValue = (0,get_size/* getSize */.a)({ size, sizes });
  const _color = color || (theme.colorScheme === "dark" ? theme.white : theme.black);
  return {
    root: {
      borderRadius: theme.radius.sm,
      width: `calc(${sizeValue} + ${theme.spacing.xs})`,
      height: `calc(${sizeValue} + ${theme.spacing.xs})`,
      padding: `calc(${theme.spacing.xs} / 2)`,
      cursor: "pointer"
    },
    burger: {
      position: "relative",
      userSelect: "none",
      boxSizing: "border-box",
      "&, &::before, &::after": {
        display: "block",
        width: sizeValue,
        height: `calc(${sizeValue} / 12)`,
        backgroundColor: _color,
        outline: `${(0,rem/* rem */.h)(1)} solid transparent`,
        transitionProperty: "background-color, transform",
        transitionDuration: `${transitionDuration}ms`,
        "@media (prefers-reduced-motion)": {
          transitionDuration: theme.respectReducedMotion ? "0ms" : void 0
        }
      },
      "&::before, &::after": {
        position: "absolute",
        content: '""',
        left: 0
      },
      "&::before": {
        top: `calc((${sizeValue} / 3) * -1)`
      },
      "&::after": {
        top: `calc(${sizeValue} / 3)`
      },
      "&[data-opened]": {
        backgroundColor: "transparent",
        "&::before": {
          transform: `translateY(calc(${sizeValue} / 3)) rotate(45deg)`
        },
        "&::after": {
          transform: `translateY(calc(-${sizeValue} / 3)) rotate(-45deg)`
        }
      }
    }
  };
});

/* harmony default export */ var Burger_styles = (useStyles);
//# sourceMappingURL=Burger.styles.js.map

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/UnstyledButton/UnstyledButton.js + 1 modules
var UnstyledButton = __webpack_require__(12610);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Burger/Burger.js





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  size: "md",
  transitionDuration: 300
};
const Burger = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Burger", defaultProps, props), {
    className,
    opened,
    color,
    size,
    classNames,
    styles,
    transitionDuration,
    variant
  } = _a, others = __objRest(_a, [
    "className",
    "opened",
    "color",
    "size",
    "classNames",
    "styles",
    "transitionDuration",
    "variant"
  ]);
  const { classes, cx } = Burger_styles({ color, transitionDuration }, { classNames, styles, name: "Burger", variant, size });
  return /* @__PURE__ */ react.createElement(UnstyledButton/* UnstyledButton */.k, __spreadValues({
    className: cx(classes.root, className),
    ref
  }, others), /* @__PURE__ */ react.createElement("div", {
    "data-opened": opened || void 0,
    className: classes.burger
  }));
});
Burger.displayName = "@mantine/core/Burger";


//# sourceMappingURL=Burger.js.map

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-window-scroll/use-window-scroll.js
var use_window_scroll = __webpack_require__(65180);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-window-event/use-window-event.js
var use_window_event = __webpack_require__(12667);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-viewport-size/use-viewport-size.js



const eventListerOptions = {
  passive: true
};
function useViewportSize() {
  const [windowSize, setWindowSize] = (0,react.useState)({
    width: 0,
    height: 0
  });
  const setSize = (0,react.useCallback)(() => {
    setWindowSize({ width: window.innerWidth || 0, height: window.innerHeight || 0 });
  }, []);
  (0,use_window_event/* useWindowEvent */.s)("resize", setSize, eventListerOptions);
  (0,use_window_event/* useWindowEvent */.s)("orientationchange", setSize, eventListerOptions);
  (0,react.useEffect)(setSize, []);
  return windowSize;
}


//# sourceMappingURL=use-viewport-size.js.map

// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconChevronUp.js
var IconChevronUp = __webpack_require__(40848);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconChevronDown.js
var IconChevronDown = __webpack_require__(97547);
// EXTERNAL MODULE: ./src/config/themeOverride/getColor.ts
var getColor = __webpack_require__(55075);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var constants = __webpack_require__(95660);
;// CONCATENATED MODULE: ./src/components/site/SiteLayout/Header/images/caixuan.png
/* harmony default export */ var caixuan = ({"src":"https://static-cny.howxm.com/_next/static/media/caixuan.faf348aa.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABE0lEQVR4nAEIAff+Af+4ARX//AMGAf38APEEXQEPCKP4AA0A+fnsQA4HAsD6Af60ABsBHQD3/hZQ/QLnsPqz37MpvfolIZAaKL749UIKAf//TAv6ZrRV5ApvNiM+gxAA9vk4gwblpXwiMInz6lYQAf/HEhX2yRgZ/sLWs60rxdIrOOISNAVZxtn1kX4nCW8UAf2zABsCOgDz+1kjncRN3QceLAAWI/gg//wB4FYD/wL7Afa5ABsJ8Qb1mgcBk+AKGDb5/QTDiQHd/QT/A7H8//3EAfy3ABoDAQD7mgMBSUz6AsQaAv3r9/8AAAkBAAgAAQAFAf+3ABX9AQAFA/gA8QAHAAz3AQAFCQAA/wAAAP///wD782lv9s4KsDAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/site/SiteLayout/Header/images/ckt.png
/* harmony default export */ var ckt = ({"src":"https://static-cny.howxm.com/_next/static/media/ckt.a2ab2d20.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA10lEQVR42g3JPUoEQRRF4XtfdXXTYw8GIuIEE0xmoqHgAnQdbsR9uAtDYyMzcQsKgggmTk//VNW7Nic58HF7tz+FEAEEOdL+k9PxTq0cEJAMC9LoNeNPXDGcX+ui/+LkhU4gmhlLSWoOaXpg7S+hxfPmRpeQCFAGLjmKwPsyY5dHrS3osT1hXN4rAtkNZ967zQkw8rtq7H38xRAaRCtZTdvZBxxPBUQuXOVJh3qNqAJxe9tvSBQ0hvkvX8UGrQrflDmGWlUFKEmMHIqOuvCaB7qCd1hQQPoHp2hsGflA1T8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/site/SiteLayout/Header/images/geekRate.png
/* harmony default export */ var geekRate = ({"src":"https://static-cny.howxm.com/_next/static/media/geekRate.5d73d9ab.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAvUlEQVR42mNoWesu2rzGTQpIi7ev8+FqW+fN07rWiw8qJsoAZYgBafmmNc6lQNzRtMbFr2WthzBQTJoBRLSu9eQHSkwA4qSmNa46QAVeUE2SDCCVQEFDoOSUzg2B7M1rXHRBpgEVSDSvhSgQAgqaAhX0d2wIYAfSuU2rXRa3rHGXASqQgLlBGCgxB2i0J8g6oIJ5QHFlkDVgN0Ac5KoPVNTdtBrkFpdUoJgIzJGiMEVA3XxAoyVa13nxwrwJAJpmadsdlSahAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/site/SiteLayout/Header/images/all.png
/* harmony default export */ var images_all = ({"src":"https://static-cny.howxm.com/_next/static/media/all.b5fd715e.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAM1BMVEUdWsMcWsMcWMMdWMQdWMMdWMQcWMQcWMMdV8MdVsQcVsQdVcQcVcQdVcQdVcQcVcQdVcRauGdJAAAAEXRSTlMODhQWFhkZGR0xMU1NV3p6gTAMlR0AAAA6SURBVHjaLYtBDsAgDMPSsFG6jqz/f+2E4GbJNlo30rzBR0bkcFiWVGlgaE49PBBc6lO9wL3jjuvsP0gVAf8DbG2FAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/site/SiteLayout/Header/images/eclicktech.png
/* harmony default export */ var eclicktech = ({"src":"https://static-cny.howxm.com/_next/static/media/eclicktech.bc41479b.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAlUlEQVR42g3MPUrFUBgG4edLTkQFwcrSKouxclluxSUJViIW9perN+bn9RRTzTDl+XjA5HAROyhD57qzNTFhr9Gs3OEQS+JDtKZwWGvwghmLIrsnnBsGsYW9uOCU+BQ/ytil1ehenMMaujD14+zw25Qe+cObHuEdj+GktCboUeIVC66KW7svg5t+sIke+saAJHZdYvkHscpCcEBkZowAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/site/SiteLayout/Header/images/jsj.png
/* harmony default export */ var jsj = ({"src":"https://static-cny.howxm.com/_next/static/media/jsj.50a579c3.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAp0lEQVR42i2OLQ4CMRCFRyAAA4H9SRsW1BIUorMWzx3wOBTBgVhoAkfA4zkBjoRjFb60iK9v3nvTphK8K8IlkjFXaJm8WnwuMfA6h0VotYvOoP4vWuEYEqzgC1d4c/MQTtphrgRjeW6EPuEDd4ojOiUvhWOMUbhR7NEdPGBJlwmDoQDXwAu2oXU9yoI8/sEm42rYwBomZAaNCzmbaemsfXQAJl70Tf4D8th665YWblIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/site/SiteLayout/Header/images/nobook.png
/* harmony default export */ var nobook = ({"src":"https://static-cny.howxm.com/_next/static/media/nobook.c290f642.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAe1BMVEX/ghX/gxX/gxX/gxT/gxT/gxT/hBP/gxP/gxT/gxP/gxT/gxP/hBP+hBT+hBP+hBT+hBP+hBP+hBP+hBP9hBP9hBP9hBP9hBP9hBL9hBL9hBP9hBP9hBL9hBL9hBP9hBL9hBL9hBL9hBL9hBL9hRL9hBL9hBL9hBL9hBIqr1WmAAAAKXRSTlMMDQ4ODxAVFRYWFxcZGRkaGhskJUFESktkaIOFl5uwsc3Q2dvd6uz6+/SzPYoAAABHSURBVHjaBUAFEoAgEFwVEZG4szsw//9CB5JYKfYS3oiqTJwHi+m5R8FImyuEs06B4djWvQdssXzvnFuQ1l2rNUGSiWJH2Q+boARO+/PivAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/site/SiteLayout/Header/images/tracup.png
/* harmony default export */ var tracup = ({"src":"https://static-cny.howxm.com/_next/static/media/tracup.cbbf3f35.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAsUlEQVR42h3Ou00DQQAG4fn31vYFJkJIREAFlAIN0Bg10AISDZBSAAkkJDyEbK13B87xp5EmF3c/ZzErY4cMweAUmQytRhYcMZvoFhbIl2G/WIVkxN26cwu5BH/R3ir3MXMxtjpyCpyLj5In+C87V6OwqxDRNeRTeA9OwBsyCx4fRuGjdL8LuQEPwGGUvBbdVICYul/xsD54jZlb9bnIHFOq2Ehq7Z60KS/GUXu2gMb2B423Yd7/MfQeAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/site/SiteLayout/Header/images/ucloud.png
/* harmony default export */ var ucloud = ({"src":"https://static-cny.howxm.com/_next/static/media/ucloud.bf100624.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAxklEQVR42mOwSfsiapv2VdIu/SuIlgBh+8yvgiAxkBwDmJHyRdYy6Ys5kJazBmIg29Im9YsMSA6kQBzEsUj4PNEi8Uu4VdIXK/P4L7+BtIFdxlchBqCklEPmVwGLhC+3gLgKKGFuEf/lL7ICSRADKPkaiDOsk78qAxX8ByowtocqkHHO/cYNlNwNxKeBeBEQvwK5C2Q92AogQwzoOCWgRCPQLZOAuk2BpgoD5aQZQF6xSf0KVuRT+YMtouMPM8hKkKRt2hcRAO3fdVlnoTJvAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/site/SiteLayout/Header/constant.ts










var SiteMenus = [
    {
        name: "客户案例",
        subMenu: [
            {
                name: "全部案例",
                href: "https://howxm.com/institute/tag/cases/",
                logo: images_all.src
            },
            {
                name: "易点天下",
                href: "https://howxm.com/institute/cyberklick-case/",
                logo: eclicktech.src
            },
            {
                name: "金数据",
                href: "https://howxm.com/institute/jinshuju-case/",
                logo: jsj.src
            },
            {
                name: "创客贴",
                href: "https://howxm.com/institute/chuangkit-case/",
                logo: ckt.src
            },
            {
                name: "UCloud",
                href: "https://howxm.com/institute/ucloud-case/",
                logo: ucloud.src
            },
            {
                name: "Tracup",
                href: "https://howxm.com/institute/tracup-case/",
                logo: tracup.src
            },
            {
                name: "彩漩",
                href: "https://howxm.com/institute/caixuan-case/",
                logo: caixuan.src
            },
            {
                name: "Geek Rate",
                href: "https://howxm.com/institute/geekrate-case/",
                logo: geekRate.src
            },
            {
                name: "NOBOOK",
                href: "https://howxm.com/institute/nobook-case/",
                logo: nobook.src
            }, 
        ]
    },
    {
        name: "场景模板",
        href: constants/* Templates */.QZ
    },
    {
        name: "价格",
        href: constants/* Pricing */.nc
    },
    {
        name: "博客",
        href: constants/* Institute */.Q4
    },
    {
        name: "帮助中心",
        href: constants/* HelpCenter */.Fo,
        target: "_blank"
    },
    {
        name: "为什么选择浩客?",
        subMenu: [
            {
                name: "浩客 VS 表单问卷",
                href: constants/* whyNotSurveyCase */.Ng
            },
            {
                name: "浩客 VS 客户体验管理软件（CEM）",
                href: constants/* whyNotCemCase */.G2
            },
            {
                name: "浩客 VS 海外产品",
                href: constants/* whyNotOverseasCase */.u0
            },
            {
                name: "浩客 VS 自研弹窗",
                href: constants/* whyNotDevCase */.XP
            }, 
        ]
    }, 
];

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Image/Image.js + 2 modules
var Image = __webpack_require__(31463);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconArrowRight.js
var IconArrowRight = __webpack_require__(27665);
;// CONCATENATED MODULE: ./src/components/site/SiteLayout/Header/SubMenus/index.tsx






var SubMenus = function(param) {
    var menus = param.menus, active = param.active;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
        spacing: 0,
        children: menus.map(function(menu) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                href: menu.href,
                passHref: true,
                target: menu.target || "_self",
                className: "!no-underline px-sm py-sm hover:bg-gray-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    justify: "space-between",
                    align: "center",
                    className: "group cursor-pointer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            spacing: 12,
                            children: [
                                (menu === null || menu === void 0 ? void 0 : menu.logo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    src: menu.logo,
                                    width: 32,
                                    className: "".concat(active ? "opacity-100" : "opacity-80 group-hover:opacity-100", " "),
                                    alt: menu.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    color: "gray.9",
                                    weight: 600,
                                    children: menu.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowRight/* default */.Z, {
                            size: 18,
                            stroke: 2,
                            color: (0,getColor/* getTextColor */.uu)("gray.9", theme),
                            className: "mr-[4px] opacity-0 ease-in duration-200 transition-all group-hover:opacity-100 group-hover:translate-x-[4px]"
                        })
                    ]
                })
            }, menu.name);
        })
    });
};
/* harmony default export */ var Header_SubMenus = (SubMenus);

;// CONCATENATED MODULE: ./src/components/site/SiteLayout/Header/hooks/useActivatedMenus.ts

function useActivatedMenus() {
    var ref = (0,react.useState)([]), activatedMenus = ref[0], setActivatedMenus = ref[1];
    var toggleMenu = function(menuName) {
        var activated = getActivated(menuName);
        if (activated) {
            setActivatedMenus(activatedMenus.filter(function(menu) {
                return menu != menuName;
            }));
        } else {
            setActivatedMenus(activatedMenus.concat(menuName));
        }
    };
    var getActivated = function(menuName) {
        return activatedMenus.includes(menuName);
    };
    return {
        toggleMenu: toggleMenu,
        getActivated: getActivated
    };
}

// EXTERNAL MODULE: ./src/hooks/index.ts + 8 modules
var hooks = __webpack_require__(33892);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/link.js
var next_link = __webpack_require__(19032);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var router = __webpack_require__(73654);
// EXTERNAL MODULE: ./src/service/index.ts
var service = __webpack_require__(90309);
;// CONCATENATED MODULE: ./src/components/site/SiteLayout/Header/HeaderBar/loginOrSignupButton.tsx








var LoginOrSignupButton = function() {
    var mounted = (0,hooks/* useMounted */.s4)();
    var query = (0,router.useRouter)().query;
    if (!mounted) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {});
    }
    var hasLogin = service/* default.getSystemToken */.Z.getSystemToken();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        position: "right",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: {
                    pathname: constants/* Login */.m3,
                    query: query
                },
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    component: "a",
                    variant: "default",
                    children: hasLogin ? "进入系统" : "登录"
                })
            }),
            !hasLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: {
                    pathname: constants/* Signup */.Al,
                    query: query
                },
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    component: "a",
                    children: "免费注册"
                })
            })
        ]
    });
};
/* harmony default export */ var loginOrSignupButton = (LoginOrSignupButton);

;// CONCATENATED MODULE: ./src/components/site/SiteLayout/Header/HeaderBar/index.tsx













var getColorAlpha = function(scrollDistance, viewportHeight) {
    if (viewportHeight === 0) {
        return 0;
    }
    if (scrollDistance >= viewportHeight) {
        return 1;
    }
    return scrollDistance / viewportHeight;
};
var HeaderBar = function(param) {
    var drawerOpened = param.drawerOpened, drawerOnClick = param.drawerOnClick;
    var ref = useActivatedMenus(), toggleMenu = ref.toggleMenu, getActivated = ref.getActivated;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,use_window_scroll/* useWindowScroll */.b)(), 1), ref2 = ref1[0], scrollY = ref2.y;
    var ref3 = useViewportSize(), viewportHeight = ref3.height;
    var shadowAlpha = getColorAlpha(scrollY, viewportHeight);
    var backgroundAlpha = getColorAlpha(scrollY, 200);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
        height: "60px",
        className: "top-0 fixed",
        withBorder: false,
        style: {
            borderBottom: "1px solid rgba(227, 229, 232, ".concat(shadowAlpha, ")"),
            boxShadow: "0px 1px 8px rgba(0, 0, 0, ".concat(shadowAlpha * 0.05, ")"),
            backgroundColor: "rgba(255, 255, 255, ".concat(backgroundAlpha, ")")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            size: 1440,
            className: "h-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                position: "apart",
                className: "h-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                        href: constants/* Index */.gm,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Logo */.TR, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQuery/* MediaQuery */.z, {
                        query: "(max-width: ".concat(theme.breakpoints.xs, ")"),
                        styles: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                    component: "nav",
                                    sx: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "48px",
                                        marginRight: "44px"
                                    },
                                    children: SiteMenus.map(function(menu, index) {
                                        var activated = getActivated(menu.name);
                                        var menuLabel = /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            className: "hover:text-[#212529] " + (getActivated(menu.name) ? "text-[#212529]" : ""),
                                            color: "gray.7",
                                            weight: theme.headings.fontWeight,
                                            children: menu.name
                                        });
                                        return menu.subMenu ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard/* HoverCard */.z, {
                                            width: index === 0 ? 280 : 190,
                                            shadow: "md",
                                            onClose: function() {
                                                return toggleMenu(menu.name);
                                            },
                                            onOpen: function() {
                                                return toggleMenu(menu.name);
                                            },
                                            radius: "md",
                                            withinPortal: true,
                                            zIndex: 1005,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Target */.z.Target, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                                        align: "center",
                                                        className: "cursor-pointer",
                                                        gap: 6,
                                                        children: [
                                                            menuLabel,
                                                            activated ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChevronUp/* default */.Z, {
                                                                size: 16,
                                                                stroke: 2,
                                                                color: (0,getColor/* getTextColor */.uu)("gray.9", theme)
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChevronDown/* default */.Z, {
                                                                size: 16,
                                                                stroke: 2,
                                                                color: (0,getColor/* getTextColor */.uu)("gray.9", theme)
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Dropdown */.z.Dropdown, {
                                                    py: "xs",
                                                    px: 0,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_SubMenus, {
                                                        menus: menu.subMenu
                                                    })
                                                })
                                            ]
                                        }, menu.name) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                                            href: {
                                                pathname: menu.href
                                            },
                                            underline: false,
                                            target: menu.target || "_self",
                                            children: menuLabel
                                        }, menu.name);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                    w: 180,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loginOrSignupButton, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Burger, {
                        size: "sm",
                        opened: drawerOpened,
                        onClick: drawerOnClick,
                        className: "xs:hidden"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Header_HeaderBar = (HeaderBar);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+utils@6.0.13_react@18.2.0/node_modules/@mantine/utils/esm/create-safe-context/create-safe-context.js
var create_safe_context = __webpack_require__(62258);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Drawer/Drawer.context.js


const [DrawerProvider, useDrawerContext] = (0,create_safe_context/* createSafeContext */.R)("Drawer component was not found in tree");


//# sourceMappingURL=Drawer.context.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Drawer/DrawerRoot/DrawerRoot.styles.js


const DrawerRoot_styles_sizes = {
  xs: (0,rem/* rem */.h)(320),
  sm: (0,rem/* rem */.h)(380),
  md: (0,rem/* rem */.h)(440),
  lg: (0,rem/* rem */.h)(620),
  xl: (0,rem/* rem */.h)(780)
};
var DrawerRoot_styles_useStyles = (0,create_styles/* createStyles */.k)((theme, { position }, { size }) => ({
  header: {
    zIndex: 1e3
  },
  content: {
    flex: position === "right" || position === "left" ? `0 0 ${(0,get_size/* getSize */.a)({ size, sizes: DrawerRoot_styles_sizes })}` : "0 0 100%",
    maxWidth: "100%",
    maxHeight: "100%",
    height: position === "right" || position === "left" ? "100%" : (0,get_size/* getSize */.a)({ size, sizes: DrawerRoot_styles_sizes }),
    borderRadius: 0,
    overflowY: "auto"
  },
  inner: {
    display: "flex",
    justifyContent: position === "right" ? "flex-end" : "flex-start",
    alignItems: position === "bottom" ? "flex-end" : "flex-start"
  }
}));

/* harmony default export */ var DrawerRoot_styles = (DrawerRoot_styles_useStyles);
//# sourceMappingURL=DrawerRoot.styles.js.map

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ModalBase/ModalBase.js + 37 modules
var ModalBase = __webpack_require__(98365);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Drawer/DrawerRoot/DrawerRoot.js






var DrawerRoot_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var DrawerRoot_getOwnPropSymbols = Object.getOwnPropertySymbols;
var DrawerRoot_hasOwnProp = Object.prototype.hasOwnProperty;
var DrawerRoot_propIsEnum = Object.prototype.propertyIsEnumerable;
var DrawerRoot_defNormalProp = (obj, key, value) => key in obj ? DrawerRoot_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var DrawerRoot_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (DrawerRoot_hasOwnProp.call(b, prop))
      DrawerRoot_defNormalProp(a, prop, b[prop]);
  if (DrawerRoot_getOwnPropSymbols)
    for (var prop of DrawerRoot_getOwnPropSymbols(b)) {
      if (DrawerRoot_propIsEnum.call(b, prop))
        DrawerRoot_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var DrawerRoot_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (DrawerRoot_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && DrawerRoot_getOwnPropSymbols)
    for (var prop of DrawerRoot_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && DrawerRoot_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const transitions = {
  top: "slide-down",
  bottom: "slide-up",
  left: "slide-right",
  right: "slide-left"
};
const rtlTransitions = {
  top: "slide-down",
  bottom: "slide-up",
  right: "slide-right",
  left: "slide-left"
};
const DrawerRoot_defaultProps = __spreadProps(DrawerRoot_spreadValues({}, ModalBase/* ModalBaseDefaultProps */.K), {
  position: "left"
});
function DrawerRoot(props) {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("DrawerRoot", DrawerRoot_defaultProps, props), { classNames, variant, size, scrollAreaComponent, position, transitionProps } = _a, others = DrawerRoot_objRest(_a, ["classNames", "variant", "size", "scrollAreaComponent", "position", "transitionProps"]);
  const { classes, cx, theme } = DrawerRoot_styles({ position }, { name: "Drawer", variant, size });
  const drawerTransition = (theme.dir === "rtl" ? rtlTransitions : transitions)[position];
  return /* @__PURE__ */ react.createElement(DrawerProvider, {
    value: { scrollAreaComponent }
  }, /* @__PURE__ */ react.createElement(ModalBase/* ModalBase */.e, DrawerRoot_spreadValues({
    __staticSelector: "Drawer",
    size,
    variant,
    transitionProps: DrawerRoot_spreadValues({ transition: drawerTransition, duration: 200 }, transitionProps),
    classNames: __spreadProps(DrawerRoot_spreadValues({}, classNames), {
      content: cx(classes.content, classNames == null ? void 0 : classNames.content),
      inner: cx(classes.inner, classNames == null ? void 0 : classNames.inner)
    })
  }, others)));
}


//# sourceMappingURL=DrawerRoot.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Drawer/DrawerContent/DrawerContent.js





var DrawerContent_defProp = Object.defineProperty;
var DrawerContent_getOwnPropSymbols = Object.getOwnPropertySymbols;
var DrawerContent_hasOwnProp = Object.prototype.hasOwnProperty;
var DrawerContent_propIsEnum = Object.prototype.propertyIsEnumerable;
var DrawerContent_defNormalProp = (obj, key, value) => key in obj ? DrawerContent_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var DrawerContent_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (DrawerContent_hasOwnProp.call(b, prop))
      DrawerContent_defNormalProp(a, prop, b[prop]);
  if (DrawerContent_getOwnPropSymbols)
    for (var prop of DrawerContent_getOwnPropSymbols(b)) {
      if (DrawerContent_propIsEnum.call(b, prop))
        DrawerContent_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var DrawerContent_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (DrawerContent_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && DrawerContent_getOwnPropSymbols)
    for (var prop of DrawerContent_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && DrawerContent_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DrawerContent_defaultProps = {
  shadow: "xl"
};
const DrawerContent = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("ModalContent", DrawerContent_defaultProps, props), { children, scrollAreaComponent } = _a, others = DrawerContent_objRest(_a, ["children", "scrollAreaComponent"]);
  const ctx = useDrawerContext();
  const Scroll = scrollAreaComponent || ctx.scrollAreaComponent || ModalBase/* ModalBase.NativeScrollArea */.e.NativeScrollArea;
  return /* @__PURE__ */ react.createElement(ModalBase/* ModalBase.Content */.e.Content, DrawerContent_spreadValues({
    ref,
    radius: 0
  }, others), /* @__PURE__ */ react.createElement(Scroll, {
    style: { height: "100vh" }
  }, children));
});


//# sourceMappingURL=DrawerContent.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Drawer/Drawer.js






var Drawer_defProp = Object.defineProperty;
var Drawer_defProps = Object.defineProperties;
var Drawer_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Drawer_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Drawer_hasOwnProp = Object.prototype.hasOwnProperty;
var Drawer_propIsEnum = Object.prototype.propertyIsEnumerable;
var Drawer_defNormalProp = (obj, key, value) => key in obj ? Drawer_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Drawer_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Drawer_hasOwnProp.call(b, prop))
      Drawer_defNormalProp(a, prop, b[prop]);
  if (Drawer_getOwnPropSymbols)
    for (var prop of Drawer_getOwnPropSymbols(b)) {
      if (Drawer_propIsEnum.call(b, prop))
        Drawer_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Drawer_spreadProps = (a, b) => Drawer_defProps(a, Drawer_getOwnPropDescs(b));
var Drawer_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Drawer_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Drawer_getOwnPropSymbols)
    for (var prop of Drawer_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Drawer_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Drawer_defaultProps = Drawer_spreadProps(Drawer_spreadValues({}, ModalBase/* ModalBaseDefaultProps */.K), {
  withOverlay: true,
  withCloseButton: true
});
function Drawer(props) {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Drawer", Drawer_defaultProps, props), {
    title,
    withOverlay,
    overlayProps,
    withCloseButton,
    closeButtonProps,
    children
  } = _a, others = Drawer_objRest(_a, [
    "title",
    "withOverlay",
    "overlayProps",
    "withCloseButton",
    "closeButtonProps",
    "children"
  ]);
  const hasHeader = !!title || withCloseButton;
  return /* @__PURE__ */ react.createElement(DrawerRoot, Drawer_spreadValues({}, others), withOverlay && /* @__PURE__ */ react.createElement(ModalBase/* ModalBase.Overlay */.e.Overlay, Drawer_spreadValues({}, overlayProps)), /* @__PURE__ */ react.createElement(DrawerContent, null, hasHeader && /* @__PURE__ */ react.createElement(ModalBase/* ModalBase.Header */.e.Header, null, title && /* @__PURE__ */ react.createElement(ModalBase/* ModalBase.Title */.e.Title, null, title), withCloseButton && /* @__PURE__ */ react.createElement(ModalBase/* ModalBase.CloseButton */.e.CloseButton, Drawer_spreadValues({}, closeButtonProps))), /* @__PURE__ */ react.createElement(ModalBase/* ModalBase.Body */.e.Body, null, children)));
}
Drawer.Root = DrawerRoot;
Drawer.CloseButton = ModalBase/* ModalBase.CloseButton */.e.CloseButton;
Drawer.Overlay = ModalBase/* ModalBase.Overlay */.e.Overlay;
Drawer.Content = DrawerContent;
Drawer.Header = ModalBase/* ModalBase.Header */.e.Header;
Drawer.Title = ModalBase/* ModalBase.Title */.e.Title;
Drawer.Body = ModalBase/* ModalBase.Body */.e.Body;
Drawer.NativeScrollArea = ModalBase/* ModalBase.NativeScrollArea */.e.NativeScrollArea;


//# sourceMappingURL=Drawer.js.map

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Divider/Divider.js + 1 modules
var Divider = __webpack_require__(63332);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Anchor/Anchor.js + 1 modules
var Anchor = __webpack_require__(98558);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconChevronRight.js
var IconChevronRight = __webpack_require__(47598);
;// CONCATENATED MODULE: ./src/components/site/SiteLayout/Header/MobileMenu/index.tsx












var MobileMenu = function(param) {
    var opened = param.opened, onClose = param.onClose;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var ref = useActivatedMenus(), toggleMenu = ref.toggleMenu, getActivated = ref.getActivated;
    var query = (0,router.useRouter)().query;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer, {
        opened: opened,
        onClose: onClose,
        size: "100%",
        padding: "md",
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Logo */.TR, {
            colorScheme: "light"
        }),
        transitionProps: {
            transition: "fade"
        },
        zIndex: 1000000,
        styles: {
            content: {
                paddingTop: "14px !important"
            },
            close: {
                color: theme.colors.gray[9]
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                color: "gray.1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                spacing: "xl",
                py: "xl",
                children: SiteMenus.map(function(menu) {
                    if (menu.subMenu) {
                        var activated = getActivated(menu.name);
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                    align: "center",
                                    w: "100%",
                                    onClick: function() {
                                        return toggleMenu(menu.name);
                                    },
                                    gap: 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            weight: theme.headings.fontWeight,
                                            children: menu.name
                                        }, menu.name),
                                        activated ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChevronRight/* default */.Z, {
                                            size: 16,
                                            stroke: 2,
                                            color: (0,getColor/* getTextColor */.uu)("gray.9", theme)
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChevronDown/* default */.Z, {
                                            size: 16,
                                            stroke: 2,
                                            color: (0,getColor/* getTextColor */.uu)("gray.9", theme)
                                        })
                                    ]
                                }),
                                activated && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_SubMenus, {
                                    menus: menu.subMenu,
                                    active: true
                                })
                            ]
                        }, menu.name);
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                            weight: theme.headings.fontWeight,
                            color: "gray.9",
                            href: menu.href,
                            underline: false,
                            target: menu.target,
                            children: menu.name
                        })
                    }, menu.name);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                mb: "md",
                color: "gray.1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                position: "center",
                grow: true,
                pb: "xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: {
                            pathname: constants/* Login */.m3,
                            query: query
                        },
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            component: "a",
                            variant: "default",
                            children: "登录"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: {
                            pathname: constants/* Signup */.Al,
                            query: query
                        },
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            component: "a",
                            size: "sm",
                            children: "免费注册"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Header_MobileMenu = (MobileMenu);

;// CONCATENATED MODULE: ./src/components/site/SiteLayout/Header/index.tsx







var Header_Header = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), drawerOpened = ref[0], ref1 = ref[1], toggleDrawer = ref1.toggle, closeDrawer = ref1.close;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderBar, {
                drawerOpened: drawerOpened,
                drawerOnClick: toggleDrawer
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ResponsiveHead */.eG, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_MobileMenu, {
                opened: drawerOpened,
                onClose: closeDrawer
            })
        ]
    });
};
/* harmony default export */ var SiteLayout_Header = (Header_Header);

// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(71557);
// EXTERNAL MODULE: ./src/plugins/howxm/useHowxmSDK.ts
var useHowxmSDK = __webpack_require__(25474);
// EXTERNAL MODULE: ./src/components/site/index.ts + 21 modules
var site = __webpack_require__(24613);
;// CONCATENATED MODULE: ./src/components/site/SiteLayout/index.tsx






var SiteLayout = function(param) {
    var children = param.children;
    (0,useHowxmSDK/* default */.Z)(config/* SiteHowXMAppId */.KP);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteLayout_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* BaiduTracking */.Of, {})
        ]
    });
};
/* harmony default export */ var site_SiteLayout = (SiteLayout);


/***/ }),

/***/ 24613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Of": function() { return /* reexport */ site_BaiduTracking; },
  "OO": function() { return /* reexport */ site_ContentContainer; },
  "ri": function() { return /* reexport */ site_Conversation; },
  "Ob": function() { return /* reexport */ site_FeatureBox; },
  "TT": function() { return /* reexport */ site_FeatureCard; },
  "OX": function() { return /* reexport */ site_FeatureHeader; },
  "$_": function() { return /* reexport */ site_Footer; },
  "V6": function() { return /* reexport */ site_FooterWrapper; },
  "yc": function() { return /* reexport */ site_GoToSignup; },
  "o9": function() { return /* reexport */ GridBackground/* default */.Z; },
  "bY": function() { return /* reexport */ site_SessionLayout; },
  "Iv": function() { return /* reexport */ SiteLayout/* default */.Z; },
  "EI": function() { return /* reexport */ site_SiteSEO; },
  "JL": function() { return /* reexport */ site_SiteTitle; },
  "Jr": function() { return /* reexport */ site_StructuredData; }
});

// UNUSED EXPORTS: ChannelSwitcher

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(71557);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/script.js
var script = __webpack_require__(3203);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
;// CONCATENATED MODULE: ./src/components/site/BaiduTracking/index.tsx




var BaiduTracking = function() {
    if (!config/* BaiduAnalyticsId */.L3) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: "baidu-sdk",
        dangerouslySetInnerHTML: {
            __html: '\n          var _hmt = _hmt || [];\n          (function() {\n            var hm = document.createElement("script");\n            hm.src = "https://hm.baidu.com/hm.js?'.concat(config/* BaiduAnalyticsId */.L3, '";\n            var s = document.getElementsByTagName("script")[0]; \n            s.parentNode.insertBefore(hm, s);\n          })();\n          ')
        }
    });
};
/* harmony default export */ var site_BaiduTracking = (BaiduTracking);

// EXTERNAL MODULE: ./src/config/themeOverride/getColor.ts
var getColor = __webpack_require__(55075);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
;// CONCATENATED MODULE: ./src/components/site/ChannelSwitcher/index.tsx





var Channel = function(param) {
    var channel = param.channel, active = param.active, onClick = param.onClick;
    var theme = useMantineTheme();
    var iconName = channel === "mobileApp" ? "mobile4Site" : channel;
    return /*#__PURE__*/ _jsx(Center, {
        sx: function() {
            return {
                width: "40px",
                height: "32px",
                background: active ? "white" : "unset",
                border: "1px solid ".concat(active ? "#E3E5E8" : "transparent"),
                boxShadow: active ? "0 8px 12px rgba(0, 0, 0, 0.05)" : "unset",
                cursor: "pointer",
                borderRadius: "6px"
            };
        },
        onClick: function() {
            return onClick(channel);
        },
        children: /*#__PURE__*/ _jsx(Icon, {
            name: iconName,
            style: {
                color: getTextColor("gray.9", theme),
                width: 24,
                height: 24
            }
        })
    });
};
var ChannelSwitcher = function(props) {
    var channels = props.channels, channel = props.channel, onClick = props.onClick;
    return /*#__PURE__*/ _jsx(Group, {
        h: 40,
        spacing: 8,
        px: 4,
        position: "center",
        align: "center",
        sx: function() {
            return {
                background: "#F6F7F8",
                borderRadius: "8px"
            };
        },
        children: channels.map(function(item) {
            return /*#__PURE__*/ _jsx(Channel, {
                channel: item,
                active: item === channel,
                onClick: onClick
            }, item);
        })
    });
};
/* harmony default export */ var site_ChannelSwitcher = ((/* unused pure expression or super */ null && (ChannelSwitcher)));

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(23723);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.2/node_modules/classnames/index.js
var classnames = __webpack_require__(90773);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/site/ContentContainer/index.tsx



var ContentContainer = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: classnames_default()(className, "w-full sm:max-w-[1440px]"),
        p: 0,
        children: children
    });
};
/* harmony default export */ var site_ContentContainer = (ContentContainer);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Flex/Flex.js + 1 modules
var Flex = __webpack_require__(26385);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Image/Image.js + 2 modules
var Image = __webpack_require__(31463);
// EXTERNAL MODULE: ./src/hooks/index.ts + 8 modules
var hooks = __webpack_require__(33892);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(68844);
;// CONCATENATED MODULE: ./src/assets/images/site/avatar/girl3.png
/* harmony default export */ var girl3 = ({"src":"https://static-cny.howxm.com/_next/static/media/girl3.83701b97.png","height":256,"width":248,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA2klEQVR42mMAgSOOjUwg+m7GFKFjya1CIPZ2pwqwGMNGwxJmEL3PrsZkg2f5270+9W/22lXpgcRWGeUxM2yqrWYFcXoCY5bvndr5f+/Ezv/l1n7rQGLry2qYGUDAw0THMC/c9dezA8t+Pz247GdGkNN/ZwN1UwYYuLRhet/NbXP/r+8t+7+up/T/ze3z/l9cP20yAwzsmtNm+PzQsl01qSETyxICJjw/uGzPrtmtIBPggBGIuYCYFYRBbLAYDPz//47x///HzJun1DGtn1DF9P//Q+b//5+CFQAAng5YHAQWZEYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/site/Conversation/index.tsx







var Conversation = function(props) {
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    var text = props.text, _position = props.position, position = _position === void 0 ? "right" : _position, _avatar = props.avatar, avatar = _avatar === void 0 ? girl3 : _avatar, _pcWidth = props.pcWidth, pcWidth = _pcWidth === void 0 ? 384 : _pcWidth, conversationClassName = props.conversationClassName, _avatarHidden = props.avatarHidden, avatarHidden = _avatarHidden === void 0 ? false : _avatarHidden;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        direction: "".concat(position === "right" ? "row" : "row-reverse"),
        justify: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                className: classnames_default()("bg-gray-9 p-[16px] rounded-[28px]", "".concat(position === "right" ? "rounded-br-md" : "rounded-bl-md"), conversationClassName),
                w: smallerScreen ? 276 : pcWidth,
                children: (0,isArray/* default */.Z)(text) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: text.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            color: "white",
                            size: smallerScreen ? "sm" : "md",
                            children: item
                        }, index);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    color: "white",
                    size: smallerScreen ? "sm" : "md",
                    children: text
                })
            }),
            !avatarHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                className: "self-end ".concat(smallerScreen ? " mb-[-30px]" : " mb-[-50px]"),
                src: avatar.src,
                width: smallerScreen ? 60 : 100,
                alt: "avatar",
                height: smallerScreen ? 60 : 100
            })
        ]
    });
};
/* harmony default export */ var site_Conversation = (Conversation);

;// CONCATENATED MODULE: ./src/components/site/FeatureBox/index.tsx



var FeatureBox = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className, _color = props.color, color = _color === void 0 ? "#F6F8F9" : _color, children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        className: className,
        sx: function() {
            return {
                background: color,
                border: "1px solid #E3E5E8",
                boxShadow: "0px 0px 0px 4px #F6F8F9",
                borderRadius: "20px",
                overflow: "hidden"
            };
        },
        children: children
    });
};
/* harmony default export */ var site_FeatureBox = (FeatureBox);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(73268);
;// CONCATENATED MODULE: ./src/components/site/FeatureCard/index.tsx





var FeatureCard = function(props) {
    var title = props.title, description = props.description, color = props.color, isIntersecting = props.isIntersecting, w = props.w, h = props.h, _direction = props.direction, direction = _direction === void 0 ? "column" : _direction, children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(site_FeatureBox, {
        color: color,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
            direction: direction,
            w: w,
            h: h,
            justify: "space-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: 8,
                    className: "pt-[32px] sm:pt-[64px] pl-[32px] sm:pl-[64px] pr-[32px] sm:pr-[0]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            weight: 900,
                            size: 24,
                            className: classnames_default()("transformSlideInBottomBase delay-150", {
                                transformSlideInBottom: isIntersecting
                            }),
                            children: title
                        }),
                        description.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                size: 16,
                                weight: 400,
                                className: classnames_default()("transformSlideInBottomBase delay-150", {
                                    transformSlideInBottom: isIntersecting
                                }),
                                children: item
                            }, index);
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    className: classnames_default()("transformSlideInBottomBaseForImg delay-300 self-end", {
                        transformSlideInBottomForImg: isIntersecting
                    }),
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ var site_FeatureCard = (FeatureCard);

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/link.js
var next_link = __webpack_require__(19032);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var router = __webpack_require__(73654);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group_Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(46550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(29848);
;// CONCATENATED MODULE: ./src/components/site/SiteTitle/index.tsx







var SiteTitle = function(_param) {
    var text = _param.text, isIntersecting = _param.isIntersecting, titleProps = (0,_object_without_properties/* default */.Z)(_param, [
        "text",
        "isIntersecting"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ta: "left",
        weight: 900
    }, titleProps), {
        className: classnames_default()("xs:!text-[40px] !text-[32px] transformSlideInBottomBase delay-150", {
            transformSlideInBottom: isIntersecting
        }),
        children: text
    }));
};
/* harmony default export */ var site_SiteTitle = (SiteTitle);

// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var constants = __webpack_require__(95660);
;// CONCATENATED MODULE: ./src/components/site/FeatureHeader/index.tsx









var FeatureHeader = function(props) {
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    var query = (0,router.useRouter)().query;
    var title = props.title, description = props.description, isIntersecting = props.isIntersecting, children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        gap: smallerScreen ? 32 : 0,
        direction: smallerScreen ? "column" : "row",
        align: "center",
        justify: "space-between",
        className: classnames_default()(smallerScreen ? "w-full" : "w-[1250px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                spacing: 0,
                px: smallerScreen ? 16 : 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(site_SiteTitle, {
                        text: title,
                        isIntersecting: isIntersecting
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        size: 16,
                        mt: smallerScreen ? 16 : 12,
                        mb: smallerScreen ? 32 : 24,
                        className: classnames_default()("transformSlideInBottomBase delay-150", {
                            transformSlideInBottom: isIntersecting
                        }),
                        children: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Group_Group/* Group */.Z, {
                        position: smallerScreen ? "center" : "left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: {
                                pathname: constants/* Signup */.Al,
                                query: query
                            },
                            passHref: true,
                            legacyBehavior: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                variant: "default",
                                style: {
                                    width: smallerScreen ? 303 : 130,
                                    height: 48,
                                    fontSize: "14px"
                                },
                                children: "免费试用"
                            })
                        })
                    })
                ]
            }),
            children
        ]
    });
};
/* harmony default export */ var site_FeatureHeader = (FeatureHeader);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Anchor/Anchor.js + 1 modules
var Anchor = __webpack_require__(98558);
// EXTERNAL MODULE: ./src/assets/images/site/avatar/boy.png
var boy = __webpack_require__(35392);
;// CONCATENATED MODULE: ./src/assets/images/site/avatar/girl10.png
/* harmony default export */ var girl10 = ({"src":"https://static-cny.howxm.com/_next/static/media/girl10.2bf1a789.png","height":200,"width":200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAxUlEQVR42mMAgRXWBUwMaGCHbxVEbK0+RHK5QYHqXu+GfcfC2k5t8CqxB4nt9q5hZjg0dRpYwRLvrONr0yr+n0ro/L/esfgpUIiFAQYsrD3dlnVV/z+3cc6v/Yv6f5U5uf9vcAqxZoABJ0vTnl2zWv6/ObHxx/2dC34lehn8BwqvY0ACtS3Jfv+Pzm/5v7I54//Lo6v/b5nWCFKkCjFBX11cU1p4F5B5uT0v5s6LQ8s+nFszeS+Qz8tgr6XAiOZDDiAWgXEA/hVNH1KgnlQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/site/Footer/index.tsx






var Footer = function() {
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    var Beian = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
            size: "xs",
            color: "gray.5",
            href: "https://beian.miit.gov.cn/",
            underline: false,
            target: "_blank",
            className: "hover:underline",
            children: "陕ICP备19008575号"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        component: "footer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            spacing: smallerScreen ? 29 : 6,
            align: "center",
            mb: smallerScreen ? 25 : 22,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group_Group/* Group */.Z, {
                    spacing: smallerScreen ? "xs" : "lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            src: boy/* default.src */.Z.src,
                            width: smallerScreen ? 60 : 100,
                            height: smallerScreen ? 60 : 100
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                            className: "hover:underline",
                            underline: false,
                            size: "md",
                            color: "gray.7",
                            href: "https://howxm.com/help/articles/product-story",
                            target: "_blank",
                            children: "\xa9️2026 金数据团队，骄傲出品"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            src: girl10.src,
                            alt: "avatar",
                            width: smallerScreen ? 60 : 100,
                            height: smallerScreen ? 60 : 100
                        })
                    ]
                }),
                smallerScreen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: 0,
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                            color: "gray.5",
                            size: "xs",
                            children: [
                                "浩客XM@2026 | 西安数据如金信息科技有限公司 |",
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            color: "gray.5",
                            size: "xs",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Beian, {})
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                    color: "gray.5",
                    size: "xs",
                    children: [
                        "浩客XM@2026 | 西安数据如金信息科技有限公司 | ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Beian, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var site_Footer = (Footer);

// EXTERNAL MODULE: ./src/components/site/FooterWrapper/index.module.scss
var index_module = __webpack_require__(43162);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/assets/images/site/footer-bg.jpg
var footer_bg = __webpack_require__(8733);
// EXTERNAL MODULE: ./src/components/ui/Divider/index.tsx
var Divider = __webpack_require__(45006);
;// CONCATENATED MODULE: ./src/components/site/FooterWrapper/index.tsx








var FooterWrapper = function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        className: classnames_default()((index_module_default()).wrapper, className),
        spacing: 0,
        sx: {
            backgroundImage: "url(".concat(footer_bg/* default.src */.Z.src, ")"),
            backgroundColor: "white",
            backgroundRepeat: "no-repeat"
        },
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(site_GoToSignup, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(site_ContentContainer, {
                className: "w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    className: "mx-[53px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        mt: 96,
                        mb: 48
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(site_Footer, {})
        ]
    });
};
/* harmony default export */ var site_FooterWrapper = (FooterWrapper);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(97684);
;// CONCATENATED MODULE: ./src/assets/images/site/avatar/girl1.png
/* harmony default export */ var girl1 = ({"src":"https://static-cny.howxm.com/_next/static/media/girl1.8ff0afe4.png","height":264,"width":264,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAArklEQVR42mMAgT/hQUwMaOCIaxMjAwh8j08CS/5NC9E7G1h3ardX48mjdpUyYEWOjUwMa208WBmAYJWO4+QdWcX/lxeU/+9zSmpmAIKpQWkgOTAQjQ5wfXJj96I/j3fM/zct1OM+AwODMAMccDO415lo/z/VnP9/TWPO/3pl6f8MeooODHCgpcxvzMBQCmRVAHEZEMelSYlxMpAEotWlmLK1pZlMNSWZbFXE4N4GAB9QMyXS59tPAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/components/site/GoToSignup/index.module.scss
var GoToSignup_index_module = __webpack_require__(76980);
var GoToSignup_index_module_default = /*#__PURE__*/__webpack_require__.n(GoToSignup_index_module);
// EXTERNAL MODULE: ./src/assets/images/site/bg.jpg
var bg = __webpack_require__(23127);
;// CONCATENATED MODULE: ./src/components/site/GoToSignup/index.tsx











var GoToSignup = function() {
    var query = (0,router.useRouter)().query;
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(site_ContentContainer, {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            className: "w-full flex justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* Paper */.X, {
                className: (GoToSignup_index_module_default()).wrapper,
                sx: {
                    backgroundImage: "url(".concat(bg/* default.src */.Z.src, ")")
                },
                px: smallerScreen ? 32 : 64,
                pt: smallerScreen ? 40 : 64,
                pb: smallerScreen ? 48 : 64,
                radius: "md",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    direction: smallerScreen ? "column" : "row",
                    justify: "space-between",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                            spacing: 0,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                    src: girl1.src,
                                    alt: "avatar",
                                    width: 100,
                                    height: 100
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    fw: 600,
                                    size: smallerScreen ? 32 : 40,
                                    color: "#F95215",
                                    children: "心动了？"
                                }),
                                !smallerScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    fw: 600,
                                    size: 40,
                                    children: "点击右侧按钮"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    fw: 600,
                                    size: smallerScreen ? 32 : 40,
                                    children: "用浩客收集用户反馈，改善产品体验"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Group_Group/* Group */.Z, {
                            className: "".concat(smallerScreen ? "mt-[120px] px-lg" : "md:self-end mt-[12px] md:mt-0"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: {
                                    pathname: constants/* Signup */.Al,
                                    query: query
                                },
                                passHref: true,
                                legacyBehavior: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    component: "a",
                                    radius: "md",
                                    size: "lg",
                                    classNames: {
                                        root: "".concat(smallerScreen ? "w-[254px]" : "w-[270px]")
                                    },
                                    children: "免费注册"
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var site_GoToSignup = (GoToSignup);

// EXTERNAL MODULE: ./src/components/site/GridBackground/index.tsx
var GridBackground = __webpack_require__(93726);
// EXTERNAL MODULE: ./src/components/site/SiteLayout/index.tsx + 24 modules
var SiteLayout = __webpack_require__(96895);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-seo@5.15.0_next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(13242);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
;// CONCATENATED MODULE: ./src/components/site/SiteSEO/index.tsx






var SiteSEO = function(param) {
    var title = param.title, description = param.description, keywords = param.keywords, ogImage = param.ogImage;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var asPath = (0,router.useRouter)().asPath;
    var path = asPath.split("?")[0].split("#")[0];
    var canonical = "".concat(constants/* brandingUrl */.$t).concat(path === "/" ? "" : path);
    var desc = description !== null && description !== void 0 ? description : t("howxm.description");
    var image = "".concat(constants/* brandingUrl */.$t).concat(ogImage !== null && ogImage !== void 0 ? ogImage : "/logo.png");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        title: title,
        description: desc,
        canonical: canonical,
        additionalMetaTags: [
            {
                name: "keywords",
                content: keywords !== null && keywords !== void 0 ? keywords : t("howxm.keywords")
            }
        ],
        openGraph: {
            type: "website",
            siteName: t("howxm.title"),
            title: title,
            description: desc,
            url: canonical,
            locale: "zh_CN",
            images: [
                {
                    url: image,
                    width: 301,
                    height: 301,
                    alt: title
                }
            ]
        },
        twitter: {
            cardType: "summary_large_image"
        }
    });
};
/* harmony default export */ var site_SiteSEO = (SiteSEO);

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/head.js
var head = __webpack_require__(89935);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/site/StructuredData/index.tsx



var StructuredData = function(param) {
    var data = param.data;
    var items = Array.isArray(data) ? data : [
        data
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: items.map(function(item, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(item)
                }
            }, i);
        })
    });
};
/* harmony default export */ var site_StructuredData = (StructuredData);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-media-query/use-media-query.js
var use_media_query = __webpack_require__(55150);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/image.js
var next_image = __webpack_require__(66401);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Center/Center.js + 1 modules
var Center_Center = __webpack_require__(91004);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(42112);
;// CONCATENATED MODULE: ./src/components/site/SessionLayout/images/bg.jpg
/* harmony default export */ var images_bg = ({"src":"https://static-cny.howxm.com/_next/static/media/bg.1a5fa704.jpg","height":1746,"width":2580,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAAsAH/xAAbEAABBAMAAAAAAAAAAAAAAAARAAESEwIxQf/aAAgBAQABPwCGdkrXB1wL/8QAFREBAQAAAAAAAAAAAAAAAAAAAAH/2gAIAQIBAT8Aj//EABURAQEAAAAAAAAAAAAAAAAAAAAB/9oACAEDAQE/AK//2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/site/SessionLayout/styles.ts


var useStyles = (0,create_styles/* createStyles */.k)(function(_theme) {
    return {
        container: {
            display: "flex",
            alignItems: "stretch",
            minHeight: "100vh"
        },
        aside: {
            width: "50vw",
            minHeight: "100vh",
            background: "radial-gradient(#EAEFF9 .9px, #F9FBFC .5px)",
            backgroundSize: "10px 10px",
            position: "relative"
        },
        center: {
            padding: "16px",
            background: "url(".concat(images_bg.src, ") center no-repeat"),
            backgroundSize: "cover"
        }
    };
});

;// CONCATENATED MODULE: ./src/components/site/SessionLayout/images/rating.png
/* harmony default export */ var rating = ({"src":"https://static-cny.howxm.com/_next/static/media/rating.3803546c.png","height":720,"width":1040,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAn0lEQVR42iVMOw7CMBRzmvQPQwdmunOWrpyKk3AIph4AFiQkBAMDM0L9keSZVLVkyfJPkdwHTgCIBSrAvc+XXVXXrwjEMBsALEkb9NRPVtrTsXk+bhslIs0yQrEcUA19b0ZPnyexNyH5gdx+u/HgrGWSpiiLUnIgJ9kakhJKceI+61wTkYxgRzi9AnVWzQ9GyEEbc6U4eC8EhdTIokjd/x14WbuVzES+AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/components/site/SessionLayout/Aside.tsx







var Aside = function() {
    var classes = useStyles().classes;
    var t = (0,useTranslation/* default */.Z)("user").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.aside,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Center_Center/* Center */.M, {
            className: "h-full " + classes.center,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                align: "center",
                justify: "center",
                spacing: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                        order: 1,
                        size: 36,
                        weight: 900,
                        mt: "md",
                        lh: "46px",
                        sx: {
                            fontFamily: "Noto Sans SC"
                        },
                        children: t("sessionLayout.slogan")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        mt: "md",
                        mb: "xl",
                        size: 16,
                        sx: {
                            fontFamily: "Noto Sans SC"
                        },
                        children: t("sessionLayout.desc")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: rating,
                        alt: "",
                        width: 520,
                        height: 360
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var SessionLayout_Aside = (Aside);

// EXTERNAL MODULE: ./src/plugins/howxm/useHowxmSDK.ts
var useHowxmSDK = __webpack_require__(25474);
;// CONCATENATED MODULE: ./src/components/site/SessionLayout/index.tsx











var SessionLayout = function(param) {
    var hideAside = param.hideAside, logoCenter = param.logoCenter, children = param.children;
    var classes = useStyles().classes;
    var matches = (0,use_media_query/* useMediaQuery */.a)("(min-width: 1000px)");
    (0,useHowxmSDK/* default */.Z)(config/* SiteHowXMAppId */.KP);
    var t = (0,useTranslation/* default */.Z)("pageLogin").t;
    var showAside = !hideAside && matches;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ResponsiveHead */.eG, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                        py: "lg",
                        sx: {
                            maxWidth: "initial",
                            width: showAside ? "50vw" : "100vw",
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                align: "center",
                                justify: logoCenter ? "center" : "space-between",
                                pt: logoCenter ? "sm" : undefined,
                                px: "xl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                                    href: "https://cny.howxm.com",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Logo */.TR, {})
                                })
                            }),
                            children
                        ]
                    }),
                    showAside && /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionLayout_Aside, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(site_BaiduTracking, {})
        ]
    });
};
/* harmony default export */ var site_SessionLayout = (SessionLayout);

;// CONCATENATED MODULE: ./src/components/site/index.ts


















/***/ }),

/***/ 43162:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FooterWrapper_wrapper__MIx18"};

/***/ }),

/***/ 76980:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GoToSignup_wrapper__ZDGlB"};

/***/ }),

/***/ 14512:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"GridBackground_grid__Yl2PG"};

/***/ })

}]);